"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaDataAudioToJSON = exports.CaptchaDataAudioFromJSONTyped = exports.CaptchaDataAudioFromJSON = void 0;
var _1 = require("./");
function CaptchaDataAudioFromJSON(json) {
    return CaptchaDataAudioFromJSONTyped(json, false);
}
exports.CaptchaDataAudioFromJSON = CaptchaDataAudioFromJSON;
function CaptchaDataAudioFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataUrl': json['dataUrl'],
        'width': json['width'],
        'height': json['height'],
        'params': (0, _1.CaptchaDataAudioParamsFromJSON)(json['params']),
    };
}
exports.CaptchaDataAudioFromJSONTyped = CaptchaDataAudioFromJSONTyped;
function CaptchaDataAudioToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataUrl': value.dataUrl,
        'width': value.width,
        'height': value.height,
        'params': (0, _1.CaptchaDataAudioParamsToJSON)(value.params),
    };
}
exports.CaptchaDataAudioToJSON = CaptchaDataAudioToJSON;
//# sourceMappingURL=CaptchaDataAudio.js.map